import {
  DELETE_DEVICE_APPLICATION_API,
  GET_DEVICE_APPLICATION_API,
  GET_DEVICE_APPLICATION_VERSION_API,
  GET_OPTIONAL_DEVICE_APPLICATIONS_API,
  GET_REQUIRED_DEVICE_APPLICATIONS_API,
  IMPORT_DEVICE_APPLICATION_API,
  OBSOLETE_DEVICE_APPLICATION_API,
  OBSOLETE_DEVICE_APPLICATION_VERSION_API,
  SEARCH_DEVICE_APPLICATION_API,
  SEARCH_DEVICE_APPLICATION_VERSION_API
} from '~/constants/APIs'
import {
  IDeviceApplicationDetail,
  IDeviceApplicationSearchRequest,
  IDeviceApplicationSearchResponse,
  IDeviceApplicationVersionDetail,
  IDeviceApplicationVersionSearchRequest,
  IDeviceApplicationVersionSearchResponse,
  IObsoleteDeviceApplicationRequest,
  IObsoleteDeviceApplicationVersionRequest,
  IOptionalApplicationRequest,
  OptionalDeviceApplicationsType,
  RequiredDeviceApplicationType
} from '~/models'
import axiosClient from './axiosClient'

export const deviceApplicationApis = {
  getOptionalApplications: (params: IOptionalApplicationRequest) =>
    axiosClient.get(GET_OPTIONAL_DEVICE_APPLICATIONS_API, {
      params
    }) as unknown as OptionalDeviceApplicationsType[],

  getRequiredApplications: (
    deviceApplicationId: number | null,
    deviceApplicationVersionId: number | null
  ) =>
    axiosClient.get(GET_REQUIRED_DEVICE_APPLICATIONS_API + deviceApplicationId, {
      params: {
        deviceApplicationVersionId
      }
    }) as unknown as RequiredDeviceApplicationType[],

  search: (params: IDeviceApplicationSearchRequest) =>
    axiosClient.get(SEARCH_DEVICE_APPLICATION_API, {
      params
    }) as unknown as IDeviceApplicationSearchResponse,

  searchversion: (params: IDeviceApplicationVersionSearchRequest) =>
    axiosClient.get(SEARCH_DEVICE_APPLICATION_VERSION_API, {
      params
    }) as unknown as IDeviceApplicationVersionSearchResponse,

  getDetails: (id: number | string) =>
    axiosClient.get(
      GET_DEVICE_APPLICATION_API + id
    ) as unknown as IDeviceApplicationDetail,

  getVersionDetails: (id: number | string) =>
    axiosClient.get(
      GET_DEVICE_APPLICATION_VERSION_API + id
    ) as unknown as IDeviceApplicationVersionDetail,

  import: (data: File[]) => {
    const formData = new FormData()
    data.forEach(item => formData.append('formFiles', item))
    return axiosClient.post(IMPORT_DEVICE_APPLICATION_API, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  obsolete: (data: IObsoleteDeviceApplicationRequest) =>
    axiosClient.post(OBSOLETE_DEVICE_APPLICATION_API, data),

  obsoleteversion: (data: IObsoleteDeviceApplicationVersionRequest) =>
    axiosClient.post(OBSOLETE_DEVICE_APPLICATION_VERSION_API, data),

  delete: (data: number[]) => axiosClient.delete(DELETE_DEVICE_APPLICATION_API, { data })
}
